import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PartsMovementSearchRequest } from 'src/app/wings-mobile/models/part-movement/parts-movement-search-request.model';
import { PartsMovementSearchResponse } from 'src/app/wings-mobile/models/part-movement/parts-movement-search-response.model';
import { LocationTO, PartsMovementSaveRequest } from '../../models/part-movement/parts-movement-save-request.model';

@Injectable({
	providedIn: 'root'
})
export class PartsMovementService {

	private httpOptions = { headers: new HttpHeaders({ 'Content-type': 'application/json' }) };
	private subRoute = "/api/v1/parts-movement";

	constructor(private http: HttpClient) {
		this.http = http;
	}

	postSearch(request: PartsMovementSearchRequest): Observable<PartsMovementSearchResponse[]> {
		const URL = environment.inbound_url + this.subRoute + '/search';
		return this.http.post<PartsMovementSearchResponse[]>(URL, request);
	}

	findByLocation(bkLocationC: string, warehouseUidK: number) {
		const URL = environment.inbound_url + this.subRoute + `/findByLocation/${bkLocationC}/${warehouseUidK}`;
		return this.http.get<LocationTO>(URL);
	}

	findByMovement(bkLocationC: string, warehouseUidK: number, bkPartWhUidD: number) {
		const URL = environment.inbound_url + this.subRoute + `/findByMovement/${bkLocationC}/${warehouseUidK}/${bkPartWhUidD}`;
		return this.http.get<PartsMovementSearchResponse[]>(URL);
	}

	postMoveLocation(request: PartsMovementSaveRequest): Observable<any> {
		const URL = environment.inbound_url + this.subRoute + '/moveLocation';
		return this.http.post<any>(URL, request, this.httpOptions);
	}

	findLocationSugestionForPart(bkWarehouseUidD: number, popims: string): Observable<string> {
		const headers = new HttpHeaders({ 'Content-type': 'text/plain' })
		const urlCompleto = environment.inbound_url + this.subRoute + `/findLocationSugestionForPart/${bkWarehouseUidD}/${popims}`;
		return this.http.get<string>(urlCompleto, { headers, responseType: 'text' as 'json' });
	}
}
